/* unplugin-vue-components disabled */import { render } from "./font-icon.vue?vue&type=template&id=72c76bba&scoped=true"
import script from "./font-icon.vue?vue&type=script&lang=js"
export * from "./font-icon.vue?vue&type=script&lang=js"

import "./font-icon.vue?vue&type=style&index=0&id=72c76bba&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c76bba"]])

export default __exports__